export default "__VITE_ASSET__BWQ8iWBy__"